import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ViewType, ViewTypeForPageLoad } from '../../interfaces/view-type.enum';
import { BreakpointObserverService } from '../../services/breakpoint-observer/breakpoint-observer.service';

@Component({ template: '' })
export abstract class TabComponent {
    ViewType = ViewType;

    viewType: ViewType;

    isMobileView: boolean;
    isTabletView: boolean;

    protected readonly breakpointObserver = inject(BreakpointObserverService);

    protected readonly changeDetector = inject(ChangeDetectorRef);

    onViewTypeChange() {
        this.changeDetector.detectChanges();
    }

    protected subscribeOnBreakpointChange() {
        this.breakpointObserver.isMobileView$
            .pipe(takeUntil(this.destroy))
            .subscribe((isMobileView: boolean) => {
                if (isMobileView) {
                    this.viewType = ViewType.Card;
                }
                this.isMobileView = Boolean(isMobileView);
                this.changeDetector.detectChanges();
            });
        this.breakpointObserver.isTabletView$
            .pipe(takeUntil(this.destroy))
            .subscribe(
                (isTabletView: boolean) => {
                    this.isTabletView = Boolean(isTabletView);
                    this.changeDetector.detectChanges();
            });
    }

    protected abstract saveViewTypeSelection(): void;

    protected abstract restoreViewTypeSelection(): void;

    protected abstract get destroy(): Subject<void>;

    getViewTypeForPageLoad(viewType: ViewType): ViewTypeForPageLoad {
        return viewType === ViewType.Card
            ? ViewTypeForPageLoad.CARD_VIEW
            : ViewTypeForPageLoad.TABLE_VIEW;
    }
}